import { STATUS_TYPE } from '../../../enum';

export interface GetPossessionType {
  id: string;
}

export interface FindPossessionType {
  activeOnly?: boolean;
  search?: string;
  limit?: number;
  skip?: number;
}

export interface PossessionType {
  id: string;
  labelEn: string;
  labelAr: string;
  icon: string;
  position: string;
  activeState: boolean;
  createdBy: string;
  updatedBy: string;
  updatedAt: string;
  createdAt: string;
}

interface InitialState {
  data: PossessionType[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  hasMore: boolean;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 5,
  totalRecords: 0,
  currentPage: 0,
  hasMore: true,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
